<template>
  <div>
    <!--begin::Instruction-->

    <!--begin::Hero-->
    <div
      class="d-flex flex-row-fluid bgi-size-cover bgi-position-top"
      :style="backgroundImage"
    >
      <div class=" container ">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-center pt-25 pb-35"
        >
          <h3 class="font-weight-bolder mb-0 text-white">
            {{ $t("instruction.title") }}
          </h3>
          <div class="d-flex">
            <a href="https://okolo.com.ua/collaboration" class="font-size-h4 font-weight-bold  text-dark">{{
              $t("instruction.contact_us")
            }}</a>
          </div>
        </div>
      </div>
    </div>
    <!--end::Hero-->

    <!--begin::Section-->
    <div class=" container  mt-n15">
      <div class="card mb-8">
        <!--begin::Body-->
        <div class="card-header">
          <h3 class="card-label">
            {{ $t("instruction.how_send") }}
          </h3>
        </div>
        <div class="card-body p-10">
          <!--begin::Row-->
          <div class="row">
            <div class="col-lg-4 mb-4 mb-lg-0">
              <iframe
                width="390"
                height="220"
                src="https://www.youtube.com/embed/tOVGExSlmzI"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-2">
              <div
                class="d-flex flex-column justify-content-center align-items-center"
              >
                <div class="symbol symbol-90">
                  <img src="media/svg/files/pdf.svg" alt="" />
                </div>
                <a
                  href="https://docs.google.com/presentation/d/1iipoWKqoltG6DfUD-eJgMEcQ5l_6q-fJarIapxZgie8/edit#slide=id.g8e2c4fa38d_0_23"
                  target="_blank"
                  class="mt-3 text-center"
                >
                  {{ $t("instruction.presentation") }}
                </a>
              </div>
            </div>
          </div>
          <!--end::Row-->
        </div>
        <!--end::Body-->
      </div>
    </div>
    <!--end::Section-->
    <!--end::Instruction-->
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters } from "vuex";
import { REMOVE_BODY_CLASSNAME } from "@/core/services/store/htmlclass.module.js";

export default {
  name: "instruction",

  data() {
    return {};
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    backgroundImage() {
      return (
        "background-image: url(" +
        process.env.BASE_URL +
        "media/home-office-1575464_960_7201.jpg);     background-position: center"
      );
    }
  },
  mounted() {
    var d = document.getElementById("kt_aside_tab_4");
    d.className += " btn-clean active";
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Instruction" }]);
    document.getElementById("d-flex-py").removeAttribute("class");
    document.getElementById("layout-container").removeAttribute("class");
    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
  }
};
</script>
